// extracted by mini-css-extract-plugin
export default {"form":"ArticleEmbedDialog_form__MBe61","code":"ArticleEmbedDialog_code__AzfTM"};